import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useApolloClient } from '@apollo/client';
import { UserContext } from '../../App';
import useSessionStorageService from '../../services/session';

function NRAccessDenied() {
  const theme = useTheme();
  const { currentOrg, orgs } = useContext(UserContext);
  const { logout, user } = useAuth0();
  const client = useApolloClient();
  const { clearUserSessionData } = useSessionStorageService();
  const logoutUrl = process.env.REACT_APP_AUTH0_REDIRECT_URL;
  const hasMultipleOrgs = (orgs?.length ?? 0) > 1;
  const orgLabel = currentOrg || 'this organization';

  const handleLogout = () => {
    client.clearStore();
    clearUserSessionData();

    if (user) {
      logout({
        returnTo: logoutUrl
      });
    }
  };

  return (
    <Box
      sx={{
        margin: theme.spacing(1, 1, 0),
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default
      }}
    >
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: 50,
          backgroundColor: theme.palette.background.paper,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Typography variant="h1" color={theme.palette.neutral[300]}>
          403
        </Typography>
      </Box>
      <Typography sx={{ marginTop: theme.spacing(2) }} variant="label" color={theme.palette.neutral[300]}>
        Access Denied
      </Typography>
      <Typography variant="caption" sx={{ marginTop: theme.spacing(2), textAlign: 'center', maxWidth: 480 }}>
        You do not have any permissions for {orgLabel}.
      </Typography>
      <Typography variant="caption" sx={{ textAlign: 'center', maxWidth: 480 }}>
        Please contact your administrator to request access.
      </Typography>
      {hasMultipleOrgs && (
        <Typography variant="caption" sx={{ marginTop: theme.spacing(1), textAlign: 'center', maxWidth: 480 }}>
          If you belong to another organization, use the organization selector above to switch.
        </Typography>
      )}
      <Box display="flex" mt={2} gap={2}>
        <Button variant="contained" color="secondary" onClick={handleLogout}>
          Log Out
        </Button>
      </Box>
    </Box>
  );
}

export default NRAccessDenied;
